import PropTypes from 'prop-types';
import styles from './styles.scss';
import Title from '../../../event_components/title';
import { LocationItem } from '../../../new-event-layouts/shared/location-item/location-item';
import { EventDate } from '../../../event_components/event-date';

import { EventTime } from '../../../event_components/event-time';
import { EventLink } from '../../../event_components/event-link';
import React, { useState } from 'react';
import cn from 'classnames';
import { Map } from 'immutable';
import CheckoutController from '../../../event_components/Checkout';
import AttendButton from '../../../event_components/attend_button';
import Details from '../../../event_components/details';
import { openModal } from '~actions/component_actions';
import WatchLaterSharpIcon from '@mui/icons-material/WatchLaterSharp';
import DateRangeIcon from '@mui/icons-material/DateRange';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const MobileListFirstView = ({ event, settings, onResizeComponent }) => {
  const isShowLocation = !event.get('venue', Map()).get('address').isEmpty();
  const [ticketOpen, setTicketOpen] = useState(false);
  const [showDescription, setShowDescription] = useState(false);

  return (
    <CheckoutController
      variant="default"
      event={event}
      settings={settings}
      openTicketing={ticketOpen}
      inClassName={styles.customCheckout}
      onResizeComponent={onResizeComponent}
      onClose={() => {
        setTicketOpen(false);
      }}
    >
      <React.Fragment>
        <div className={styles.wrapper}>
          <img
            className={styles.logo}
            src={event.get('logo').get('url')}
            alt="x"
            onClick={() => {
              window.store.dispatch(openModal({ modalName: 'galleryModal', data: { event, isModal: true } }));
            }}
          />
          <div className={styles.info}>
            <Title event={event} settings={settings} className={styles.title} />
            <div className={styles.eventFactsList}>
              <div className={styles.factItem}>
                <DateRangeIcon alt="date" width="20px" className="date" key={event.get('id')} />
                <EventDate event={event} settings={settings} />
              </div>
              <div className={styles.factItem}>
                <WatchLaterSharpIcon alt="time" width="20px" className="date" />
                <EventTime event={event} settings={settings} />
              </div>
              {settings.get('showEventUrl') && (
                <div className={cn(styles.factItem)}>
                  <OpenInNewIcon alt="link" width="20px" className="date" />
                  <EventLink event={event} settings={settings} />
                </div>
              )}
              {isShowLocation && <LocationItem event={event} settings={settings} className={styles.locationItem} />}
            </div>
          </div>
          <div className={styles.arrowContainer} onClick={() => setShowDescription(!showDescription)}>
            <img
              className={cn(styles.arrow, { [styles.open]: showDescription })}
              src="https://cdn.ticketspot.io/widget/layout-icons/shared/colorized_arrow.svg"
              alt=">"
            />
          </div>
        </div>
        <div className={cn(styles.descriptionContainer, { [styles.open]: !!showDescription })}>
          <Details event={event} settings={settings} onResizeComponent={onResizeComponent} />
          <AttendButton isFullWidth settings={settings} event={event} handleButtonClick={() => setTicketOpen(true)} className={styles.styledButton} />
        </div>
      </React.Fragment>
    </CheckoutController>
  );
};

MobileListFirstView.propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

export default MobileListFirstView;
